// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addWidget()\"> <span translate=\"ADD_TOTAL_RAISED_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-total-raised-widget widget=\"$ctrl.widget\"></gb-edit-total-raised-widget> ";
// Exports
export default code;